<template>
  <div class="BusinessDetailsCenter_Left">


    <div class="head">
      <div class="nav">
        <div class="nav_div" :class="index==0?'nav_div_active':''" v-for="(item,index) in list" :key="index">{{item}}
        </div>
      </div>
    </div>
    <!-- 商家详情中部内容 -->


    <div class="BusinessDetailsCenterLeftContent">
      <div class="top">
        <div class="topTitle">项目介绍</div>
        <div class="topMsg">
          {{msg.introduce}}
        </div>
      </div>

      <div class="center">
        <div class="centerButton" v-if="!loginType">
          <!-- <div class="loginButton">登录后查看更多信息</div> -->
          <el-row>
            <el-col :xs="12" :sm="6" :offset="9" class="loginButton hidden-xs-only ">
              登录后查看更多信息
            </el-col>
            <el-col :xs="14" :sm="6" :offset="5" class="loginButton hidden-sm-and-up">
              登录后查看更多信息
            </el-col>
          </el-row>
        </div>
        <!-- 未登录以下内容会被隐藏 -->
        <div class="centerContent" v-else>
          <div class="centerContentLi">
            <div class="centerContentTitle">市场空间与格局</div>
            <div class="centerContentMsg">
              {{msg.structure}}
            </div>
          </div>
          <div class="centerContentLi">
            <div class="centerContentTitle">核心竞争力</div>
            <div class="centerContentMsg">
              {{msg.competitiveness}}
            </div>
          </div>
          <div class="centerContentLi">
            <div class="centerContentTitle">团队信息</div>
            <div class="centerContentTeam">
              <el-row class="centerContentTeamLi" :gutter="26" v-for="(item,index) in msg.team" :key="index">
                <el-col class="centerContentTeamImg" :xs="8" :sm="4">
                  <img src="../../../../public/static/images/team1.png" alt="">
                </el-col>
                <el-col class="centerContentTeamMsg" :xs="16" :sm="20">
                  <div class="teamTitle">
                    {{item.realname}}
                    <span>
                      {{item.companyname}}
                    </span>
                  </div>
                  <div class="teamMsg">
                    {{item.positionname}}
                  </div>
                </el-col>
              </el-row>



            </div>
          </div>
          <div class="centerContentLi">
            <div class="centerContentTitle">商业模式</div>
            <div class="centerContentMsg">
              线上视频问诊+连锁门诊+健康赋能。医儿易APP（平板端2018年11月上线，Android手机版2019年8月上线，iOS手机版2019年10月上线）提供视频咨询功能，可以一键呼叫医儿易门诊坐诊的医生进行咨询，小病无需出门，提升用户依赖性和粘度。线下门诊走到儿童身边，扎实做好基层诊疗服务，扶持医生创业，扩大门店覆盖面，响应国家好找做好家庭医生签约服务率。健康赋能以穿戴设备+家庭自助医疗站的方式，建立国民健康数据库，从一而终服务好国人。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>



  export default {
    props: {
      list: Array,
      loginType: Boolean,
      msg: Object
    },
    components: {


    },
    data() {
      return {
      };
    },
    created: function () { },
    methods: {},
  };
</script>

<style scoped>
  @media (max-width: 768px) {
    .head .nav {
      margin-left: 15px;
    }

    .head .nav_div {
      font-size: 16px;
      margin-right: 20px;
    }

  }

  .head {
    background-color: #2c2c2c;
    border-radius: 25px 25px 0 0;

  }

  .nav {
    display: flex;
    justify-content: left;
    margin-left: 31px;
  }

  .nav .nav_div:last-child {
    margin-right: 0px;
  }

  .nav_div {
    padding: 21px 0;
    margin-right: 37px;

    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #999999;
    position: relative;
  }

  .nav_div_active {
    color: #ffffff;
  }

  .nav_div_active::after {
    content: '';
    position: absolute;
    bottom: 1px;
    left: 25%;
    display: block;
    width: 41px;
    height: 5px;
    background-color: #00fefe;
    border-radius: 2px;

  }

  @media (max-width: 768px) {
    .BusinessDetailsCenterLeftContent .top {
      margin: 0 15px;
      padding-top: 25px;
    }

    .BusinessDetailsCenterLeftContent .topMsg {
      padding-bottom: 25px;
    }

    .BusinessDetailsCenterLeftContent .centerContentLi {
      margin: 0 15px;
      margin-top: 25px;
    }

    .BusinessDetailsCenterLeftContent .centerContentMsg {
      padding-bottom: 25px;
    }
  }

  .BusinessDetailsCenterLeftContent {
    background-color: #1d1d1f;
    border-radius: 0 0 25px 25px;
  }

  .top {
    color: #ffffff;
    margin: 0 30px;
    padding-top: 55px;
    border-bottom: solid 1px #dcdcdc4f;
  }

  .topTitle {

    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
  }

  .topMsg {
    margin-top: 27px;

    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 29px;
    letter-spacing: 0px;
    padding-bottom: 45px;
  }

  .center {
    margin-top: 40px;
  }

  .centerButton {
    padding-bottom: 36px;
  }

  .loginButton {
    border-radius: 17px;
    border: solid 1px #dcdcdc;

    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #dcdcdc;
    padding: 7px 27px;
    text-align: center;

  }

  .centerContent {}

  .centerContent .centerContentLi:last-child {
    border-bottom: none;
  }

  .centerContentLi {
    color: #ffffff;
    margin: 0 30px;
    margin-top: 44px;
    border-bottom: solid 1px #dcdcdc4f;
  }

  .centerContentTitle {

    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
  }

  .centerContentMsg {
    margin-top: 27px;

    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 29px;
    letter-spacing: 0px;
    padding-bottom: 45px;
  }

  .centerContentTeam {
    margin-top: 33px;
    padding-bottom: 44px;
  }

  .centerContentTeamLi {
    margin-top: 29px;
  }

  .centerContentTeamImg {
    border-radius: 50%;

  }

  .centerContentTeamImg img {
    display: block;
    margin: 0 auto;

    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .centerContentTeamMsg {
    margin-top: 20px;
  }

  .teamTitle {

    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #ffffff;
  }

  .teamTitle>span {
    margin-left: 8px;

    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 21px;
    letter-spacing: 0px;
    color: #b5b5b7;
  }

  .teamMsg {
    margin-top: 19px;

    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 21px;
    letter-spacing: 0px;
    color: #b5b5b7;
  }
</style>